import React from 'react';
import PropTypes from 'prop-types';
import GlobalFilter from './GlobalFilter';
import { isBooleanTrue, isNotNullOrUndefined } from '../../utils/objectUtils';
import IconButton from '../IconButton';
import { MdSave } from 'react-icons/md';
import { getCsvBlob } from 'tanstack-table-export-to-csv';

const TableToolbar = ({ table, singularEntityName, pluralEntityName, numSelected, addEntityModal, deleteEntityModal, preGlobalFilteredRows, setGlobalFilter, globalFilter, importButton, exportButton, otherButtons, showToolbar = true }) => {
    const handleExportCsv = () => {
        const headers = table
            .getHeaderGroups()
            .map((x) => x.headers)
            .flat();

        const rows = table.getCoreRowModel().rows;

        const csvBlob = getCsvBlob(headers, rows);
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'table-data.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    if (isBooleanTrue(showToolbar)) {
        return (
            <div className="toolbar d-flex justify-content-between align-items-center bg-light mb-3">
                {(isNotNullOrUndefined(addEntityModal) || isNotNullOrUndefined(importButton) || isNotNullOrUndefined(exportButton) || isNotNullOrUndefined(otherButtons)) ? (
                    <div className="d-flex justify-content-start">
                        {isNotNullOrUndefined(addEntityModal) ? addEntityModal : null}
                        <IconButton icon={<MdSave />} title="Export to CSV" onClick={handleExportCsv} />
                        {isNotNullOrUndefined(importButton) ? importButton : null}
                        {isNotNullOrUndefined(exportButton) ? exportButton : null}
                        {isNotNullOrUndefined(otherButtons) ? otherButtons : null}
                    </div>
                ) : null}
                <div className="d-flex align-items-center">
                    <span className="fs-5">{numSelected > 0 ? `${numSelected} ${numSelected > 1 ? pluralEntityName : singularEntityName} selected` : pluralEntityName}</span>
                </div>
                <div className="d-flex align-items-center">
                    {numSelected > 0 ? (
                        <>
                            {isNotNullOrUndefined(deleteEntityModal) ? deleteEntityModal : null}
                        </>
                    ) : (
                        <GlobalFilter
                            preGlobalFilteredRows={preGlobalFilteredRows}
                            globalFilter={globalFilter}
                            setGlobalFilter={setGlobalFilter}
                        />
                    )}
                </div>
            </div>
        );
    } else {
        return null;
    }
};

TableToolbar.propTypes = {
    singularEntityName: PropTypes.string.isRequired,
    pluralEntityName: PropTypes.string.isRequired,
    addEntityModal: PropTypes.element,
    deleteEntityModal: PropTypes.element,
    numSelected: PropTypes.number.isRequired,
    setGlobalFilter: PropTypes.func.isRequired,
    preGlobalFilteredRows: PropTypes.array.isRequired,
    globalFilter: PropTypes.any,
    exportButton: PropTypes.element,
    importButton: PropTypes.element,
    otherButtons: PropTypes.element,
    showToolbar: PropTypes.bool,
};

export default TableToolbar;